import React, { useEffect } from "react";
import { getPaymentOptions, setDefaultPaymentOption, is } from "../thunk";
import { useDispatch, useSelector } from "react-redux";
import { paymentMethods, paymentMethodsErrors } from "../selector";
import styled from "@emotion/styled";
import { PrimaryButton } from "../../Button";
import { setErrorMessage } from "../action";
import { PAYMENT_TYPES } from "../constant";

const PaymentMethodsTable = () => {
  const dispatch = useDispatch();

  const errors = useSelector((state) => paymentMethodsErrors(state));
  const methods = useSelector((state) => paymentMethods(state));

  useEffect(() => {
    dispatch(getPaymentOptions());
  }, []);

  const ErrorMessage = styled.span`
    padding: 1rem 0 0 0;
    color: red;
    display: flex;
  `;

  const Table = styled.table`
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;

    th,
    td {
      font-size: 14px;
      padding: 10px 2px;
      text-align: left;
      word-break: break-word;
      border-bottom: 1px solid #dbdbdb;

      &:last-of-type {
        width: 125px;
      }
    }
  `;

  const Name = styled.div`
    display: flex;
    flex-direction: row;
  `;

  const DefaultBadge = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px;
    height: 24px;
    width: 68px;
    background: #f5f5f5;
    border-radius: 4px;
    margin-left: 10px;
  `;

  const BadgeText = styled.p`
    letter-spacing: -0.2px;
    color: ${({ type }) => (type === "default" ? "#777984" : "white")};
    margin: 10px 0;
  `;

  const VerifiedBadge = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px;
    height: 24px;
    background: red;
    border-radius: 4px;
    margin-left: 10px;
  `;

  const CloseIcon = styled.div`
    margin-left: 15px;
    margin-top: 2px;
  `;

  const methodsRows = methods.map((m) => (
    <tr key={m.id}>
      <td>
        <Name>
          {is(m.paymentMethod, PAYMENT_TYPES.PAYPAL_ACCOUNT_BULK) &&
            "PayPal Bulk"}
          {is(m.paymentMethod, PAYMENT_TYPES.MAILCHECK_BULK) && "Mail Check"}
          {is(m.paymentMethod, PAYMENT_TYPES.ACH_BULK) &&
            `Account ${m.account.slice(2)}`}

          {m.default && (
            <DefaultBadge>
              <BadgeText type={"default"}>Default</BadgeText>
            </DefaultBadge>
          )}

          {is(m.paymentMethod, PAYMENT_TYPES.ACH_BULK) && !m.verified && (
            <VerifiedBadge>
              <BadgeText>Verification Pending</BadgeText>
            </VerifiedBadge>
          )}
        </Name>
      </td>
      <td>
        {is(m.paymentMethod, PAYMENT_TYPES.ACH_BULK) &&
          `Routing: ${m.routing.slice(5)}`}
        {is(m.paymentMethod, PAYMENT_TYPES.PAYPAL_ACCOUNT_BULK) &&
          `Account: ${m.paypalAccountEmail}`}
      </td>
      <td>
        {is(m.paymentMethod, PAYMENT_TYPES.ACH_BULK) &&
          m.verified &&
          !m.default && (
            <PrimaryButton
              onClick={() => dispatch(setDefaultPaymentOption(m.id))}
            >
              Set as Default
            </PrimaryButton>
          )}

        {!is(m.paymentMethod, PAYMENT_TYPES.ACH_BULK) && !m.default && (
          <PrimaryButton
            onClick={() => {
              dispatch(setDefaultPaymentOption(m.id));
            }}
          >
            Set as Default
          </PrimaryButton>
        )}
      </td>
    </tr>
  ));

  return (
    <>
      {errors && (
        <ErrorMessage>
          Error: {errors}{" "}
          <CloseIcon onClick={() => dispatch(setErrorMessage(""))}>
            <svg
              width="11"
              height="11"
              viewBox="0 0 11 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.7071 0.293C10.5196 0.105529 10.2652 0.000213623 10.0001 0.000213623C9.73492 0.000213623 9.48061 0.105529 9.29308 0.293L6.00008 3.586L2.70708 0.293C2.51848 0.110842 2.26588 0.0100477 2.00368 0.0123261C1.74148 0.0146045 1.49067 0.119773 1.30526 0.305182C1.11985 0.49059 1.01469 0.741402 1.01241 1.0036C1.01013 1.2658 1.11092 1.5184 1.29308 1.707L4.58608 5L1.29308 8.293C1.19757 8.38525 1.12139 8.49559 1.06898 8.6176C1.01657 8.7396 0.988985 8.87082 0.987831 9.0036C0.986677 9.13638 1.01198 9.26806 1.06226 9.39095C1.11254 9.51385 1.18679 9.6255 1.28069 9.71939C1.37458 9.81329 1.48623 9.88754 1.60913 9.93782C1.73202 9.9881 1.8637 10.0134 1.99648 10.0123C2.12926 10.0111 2.26048 9.98351 2.38249 9.9311C2.50449 9.87869 2.61483 9.80251 2.70708 9.707L6.00008 6.414L9.29308 9.707C9.48168 9.88916 9.73429 9.98995 9.99648 9.98767C10.2587 9.9854 10.5095 9.88023 10.6949 9.69482C10.8803 9.50941 10.9855 9.2586 10.9878 8.9964C10.99 8.7342 10.8892 8.4816 10.7071 8.293L7.41408 5L10.7071 1.707C10.8946 1.51947 10.9999 1.26516 10.9999 1C10.9999 0.734836 10.8946 0.480528 10.7071 0.293Z"
                fill="#C4C4C4"
              />
            </svg>
          </CloseIcon>
        </ErrorMessage>
      )}
      <Table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Details</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {methodsRows.length ? (
            methodsRows
          ) : (
            <tr>
              <td colSpan="4">No Payment Methods Found</td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
};

export { PaymentMethodsTable };
